module.exports = __webpack_public_path__ + "static/media/studio-etc2.671e7884.png";